/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Pose_Reason_Too_FarInputs */

const en_us2_body_assessment_pose_reason_too_far = /** @type {(inputs: Body_Assessment_Pose_Reason_Too_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You were too far from the phone. Come closer, to about 2 m.`)
};

const pt_br2_body_assessment_pose_reason_too_far = /** @type {(inputs: Body_Assessment_Pose_Reason_Too_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você estava longe demais do celular. Chegue mais perto, a uns 2 m.`)
};

const es_419_body_assessment_pose_reason_too_far = /** @type {(inputs: Body_Assessment_Pose_Reason_Too_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estabas demasiado lejos del teléfono. Acércate, a unos 2 m.`)
};

const pt_pt2_body_assessment_pose_reason_too_far = /** @type {(inputs: Body_Assessment_Pose_Reason_Too_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estavas demasiado longe do telemóvel. Aproxima-te, a uns 2 m.`)
};

const fr_fr2_body_assessment_pose_reason_too_far = /** @type {(inputs: Body_Assessment_Pose_Reason_Too_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu étais trop loin du téléphone. Rapproche-toi, à environ 2 m.`)
};

const de_de2_body_assessment_pose_reason_too_far = /** @type {(inputs: Body_Assessment_Pose_Reason_Too_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du warst zu weit vom Handy entfernt. Komm näher, auf etwa 2 m.`)
};

const it_it2_body_assessment_pose_reason_too_far = /** @type {(inputs: Body_Assessment_Pose_Reason_Too_FarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eri troppo lontano dal telefono. Avvicinati, a circa 2 m.`)
};

/**
* | output |
* | --- |
* | "You were too far from the phone. Come closer, to about 2 m." |
*
* @param {Body_Assessment_Pose_Reason_Too_FarInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_pose_reason_too_far = /** @type {((inputs?: Body_Assessment_Pose_Reason_Too_FarInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Pose_Reason_Too_FarInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_pose_reason_too_far(inputs)
	if (locale === "es-419") return es_419_body_assessment_pose_reason_too_far(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_pose_reason_too_far(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_pose_reason_too_far(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_pose_reason_too_far(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_pose_reason_too_far(inputs)
	return en_us2_body_assessment_pose_reason_too_far(inputs)
});
export { body_assessment_pose_reason_too_far as "body-assessment.pose_reason.too_far" }